import React from 'react';
import { useProjects } from '../../lib/ProjectContext';
import { useAuth } from '../../lib/AuthContext';
import { Button } from '../ui/button';
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from '../ui/card';
import ProjectList from './ProjectList';

interface DashboardProps {
  onCreateNew: () => void;
  onOpenProject: (projectId: string) => Promise<void>;
  onLoginRequired: () => void;
}

const Dashboard: React.FC<DashboardProps> = ({ onCreateNew, onOpenProject, onLoginRequired }) => {
  const { currentUser } = useAuth();
  const { projects } = useProjects();
  
  if (!currentUser) {
    return (
      <Card className="mb-6">
        <CardHeader>
          <CardTitle>Dashboard</CardTitle>
          <CardDescription>You need to be logged in to view your projects</CardDescription>
        </CardHeader>
        <CardContent>
          <p className="text-muted-foreground mb-4">
            Please login to access your saved projects and create new ones.
          </p>
          <Button onClick={onLoginRequired}>Login / Sign Up</Button>
        </CardContent>
      </Card>
    );
  }

  // Count active projects (non-archived)
  const activeProjectCount = projects.filter(project => !project.archived).length;

  return (
    <div className="space-y-6">
      <Card>
        <CardHeader>
          <CardTitle>Dashboard</CardTitle>
          <CardDescription>
            {activeProjectCount > 0 
              ? `${activeProjectCount} active estimate${activeProjectCount !== 1 ? 's' : ''} sorted by most recently updated`
              : 'No active estimates'}
          </CardDescription>
        </CardHeader>
        <CardContent>
          <div className="space-y-6">
            <ProjectList onOpenProject={onOpenProject} />
            
            <div className="flex justify-center pt-4">
              <Button onClick={onCreateNew}>Create New Estimate</Button>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default Dashboard; 